import { FormAutoComplete } from "@app/common-ui-components";
import { ReactNode } from "react";
import { Control, FieldValues, UseFormSetValue } from "react-hook-form";

type FmsUnitSearchProps<T extends FieldValues> = {
  label?: string;
  required?: boolean;
  disabled?: boolean;
  hiddenFieldNames?: unknown[];
  getVisibleFieldName?: (prefix: string) => string;
  prefix: string;
  setValue: UseFormSetValue<T>;
  control: Control<T>;

  showHint?: boolean;
  forceFetch?: boolean;
  controlled?: boolean;
  placeholder?: string;
  getHiddenFieldNames?: (prefix: string) => string;
  className?: string;
  notFoundContent?: ReactNode;
  extraOption?: { label: ReactNode; value: string; key: string };
  parentOnChange?: (value: string, option: Record<string, unknown>) => void;
};

export const FmsUnitSearch = <T extends FieldValues>({
  label,
  prefix,
  control,
  showHint,
  disabled,
  required,
  setValue,
  forceFetch,
  controlled,
  placeholder,
  hiddenFieldNames = [],
  getVisibleFieldName,
  getHiddenFieldNames,
  className,
  notFoundContent,
  extraOption,
  parentOnChange,
}: FmsUnitSearchProps<T>) => {
  return (
    <FormAutoComplete
      type="fms"
      label={label}
      prefix={prefix}
      className={className}
      // classes={classes}
      control={control}
      setValue={setValue}
      required={required}
      disabled={disabled}
      showHint={showHint}
      controlled={controlled}
      forceFetch={forceFetch}
      placeholder={placeholder}
      hiddenFieldNames={hiddenFieldNames}
      getVisibleFieldName={getVisibleFieldName}
      getHiddenFieldNames={getHiddenFieldNames}
      notFoundContent={notFoundContent}
      extraOption={extraOption}
      parentOnChange={parentOnChange}
    />
  );
};
